import BaseApi from './BaseApi';

export type User = {
  userId: string;
  name: string;
  logo: string;
};

/**
 * ユーザー画像取得API。
 */
class SearchUserLogoApi extends BaseApi {
  async get(params: string[]): Promise<User[]> {
    return params?.filter(Boolean).length
      ? await this.execute('searchUserLogoApi', {
          method: 'POST',
          body: {
            userIdList: params?.join(',') || ''
          }
        })
          .then(({ result }) => result.userList as User[])
          .catch(() => [])
      : new Promise((resolve) => resolve([]));
  }
}

export default SearchUserLogoApi;
